import React from 'react';

function Pagination({ currentPage, setCurrentPage, totalPages }) {

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div className="flex justify-center mt-4 space-x-2">
      {/* Previous Button */}
      <button
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-3 py-1 bg-gray-300 rounded disabled:opacity-50"
      >
        Previous
      </button>

      {/* First Page */}
      {currentPage > 2 && (
        <>
          <button
            onClick={() => handlePageChange(1)}
            className={`px-3 py-1 rounded ${
              currentPage === 1 ? 'bg-[#105255] text-white' : 'bg-gray-200'
            }`}
          >
            1
          </button>
          {currentPage > 3 && <span className="px-2">...</span>}
        </>
      )}

      {/* Previous Page */}
      {currentPage > 1 && (
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          className="px-3 py-1 rounded bg-gray-200"
        >
          {currentPage - 1}
        </button>
      )}

      {/* Current Page */}
      <button className="px-3 py-1 rounded bg-[#105255] text-white">
        {currentPage}
      </button>

      {/* Next Page */}
      {currentPage < totalPages && (
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          className="px-3 py-1 rounded bg-gray-200"
        >
          {currentPage + 1}
        </button>
      )}

      {/* Last Page */}
      {currentPage < totalPages - 1 && (
        <>
          {currentPage < totalPages - 2 && <span className="px-2">...</span>}
          <button
            onClick={() => handlePageChange(totalPages)}
            className={`px-3 py-1 rounded ${
              currentPage === totalPages
                ? 'bg-[#105255] text-white'
                : 'bg-gray-200'
            }`}
          >
            {totalPages}
          </button>
        </>
      )}

      {/* Next Button */}
      <button
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-3 py-1 bg-gray-300 rounded disabled:opacity-50"
      >
        Next
      </button>
    </div>
  );
}

export default Pagination;

